
		import * as Vue from 'vue';
		window.Vue = Vue;
		window.h = Vue.h;
	